// extracted by mini-css-extract-plugin
export default {"modalBody":"DeleteRowModal_modalBody__QmEYq","modalTitle":"DeleteRowModal_modalTitle__sdug0","step":"DeleteRowModal_step__6VOTl","actionBtns":"DeleteRowModal_actionBtns__t+Ul6"};